import { render, staticRenderFns } from "./CreditLogStat.vue?vue&type=template&id=71c185a2&scoped=true&"
import script from "./CreditLogStat.vue?vue&type=script&lang=js&"
export * from "./CreditLogStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c185a2",
  null
  
)

export default component.exports